module.exports = __webpack_public_path__ + "static/media/encerrada_herois.be76387e.jpg";